import { Link, useLocation } from 'react-router-dom';
import type { NavGroupItem } from '../nav';
import { NavGroup, NavItem, SidebarNav, usePanelLayout } from '../ui';

/**
 * Renders a sidebar config as `@alpha/ui` nav primitives.
 *
 * `SidebarNav` derives the active link from `currentPath` and force-opens the
 * group containing it; `linkComponent` swaps the plain `<a>` for React Router's
 * `Link` so navigation stays client-side.
 */
export function Nav({ groups }: { groups: NavGroupItem[] }) {
  const location = useLocation();
  const { closeSidebar } = usePanelLayout();

  return (
    <SidebarNav currentPath={location.pathname} linkComponent={Link} onNavigate={closeSidebar}>
      {groups.map((group) => {
        const Icon = group.icon;

        if (!group.items) {
          return (
            <NavItem key={group.label} href={group.to ?? '#'} icon={<Icon size={16} />} flush>
              {group.label}
            </NavItem>
          );
        }

        return (
          <NavGroup key={group.label} label={group.label} icon={<Icon size={16} />}>
            {group.items.map((item) => (
              <NavItem key={item.to} href={item.to}>
                {item.label}
              </NavItem>
            ))}
          </NavGroup>
        );
      })}
    </SidebarNav>
  );
}
